// utils
import { characterSpeech } from '@/assets/js/utils/characterSpeech';
import { createBlinkAnimation } from '@/assets/js/utils/createBlinkAnimation';
import { updateText } from '@/assets/js/utils/updateText';


// character animations
import { devyn_animations } from './devyn_animations';
import { ria_animations } from './ria_animations';
import { aye_animations } from './aye_animations';


const devyn = devyn_animations();
const ria = ria_animations();
const aye = aye_animations();


import anime from 'animejs';


const slides = []

const addSlide = (slide) => {
  slides.push(slide)
}

//- ALL SLIDES -//


// Artboard 2
addSlide((ctx) => { // Slide 1 (index 0)
  ctx.controlPanelActive = false;
  console.log('Artboard 2');

  ria.raiseRightArm({
    rotate: '-90deg',
    delay: 100,
    begin: () => {
      ctx.ria_speech();
      updateText(ctx, true, "Ria");
      ria.raiseLeftArm({
        rotate: '-90deg',
        complete: () => {
          ria.leftForeArmWave()
          ria.rightForeArmWave()
        }
      })
    },
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.riaData, 4, 50)
})


// Artboard 3
addSlide((ctx) => {
  console.log('Artboard 3');
  ctx.controlPanelActive = false;

  aye.spinAndWalk({
    flipped: true,
    left: ['50%', '57%'],
    duration: 300,
    begin: () => {
      ria.walk({
        flipped: false,
        left: ['36%', '32%'],
        duration: 300,
      })
    }
  })

  aye.raiseRightArm({
    begin: () => {
      ria.lowerLeftArm();
      ria.lowerRightArm();
    },
    complete: () => {
      setTimeout(() => {
        ctx.ayeData = ["neutral", "puke_green_orb"];
        setTimeout(() => {
          ctx.controlPanelActive = true
        }, 500)
      }, 500)
    }
  })
  characterSpeech(ctx.ayeData, 4);
  updateText(ctx, true, "Aye");
})


// Artboard 4
// Index 2
addSlide((ctx) => {
  console.log('Artboard 4');
  ctx.controlPanelActive = false;
  characterSpeech(ctx.riaData, 4)
  ctx.ria_speech()

  ria.raiseLeftArm({
    rotate: '-55deg',
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.riaData, 4)
  updateText(ctx, true, "Ria")
})


// Artboard 5
addSlide((ctx) => {
  console.log('Artboard 5');
  ctx.controlPanelActive = false;
  ctx.ria_speech()

  ria.raiseRightArm({
    rotate: '-85deg',
    begin: () => {
      ria.extendLeftArm({
        duration: 300
      })
    },
    delay: 300,
    duration: 200
  })
  aye.lowerRightArm({
    delay: 900,
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.riaData, 4)
  updateText(ctx, true, "Ria")
})


// Artboard 6
addSlide((ctx) => {
  console.log('Artboard 6');
  ctx.controlPanelActive = false;
  ctx.ria_speech()

  updateText(ctx, true, "Ria");
  characterSpeech(ctx.riaData, 4)

  ria.raiseRightArm({
    rotate: '-85deg',
    begin: () => {
      ria.extendLeftArm({
        duration: 200,
        rotate: '-120deg'
      })
    },
    delay: 700
  })
  setTimeout(() => {
    ctx.controlPanelActive = true
  }, 2000)
})


// Artboard 7
addSlide((ctx) => {
  console.log('Artboard 7');
  // console.log('cross arms')
  ctx.controlPanelActive = false;

  aye.raiseLeftForeArm({
    begin: () => {
      ctx.ayeData = ["smile", "happy_green_orb"];
      aye.raiseRightArm()
      ria.lowerLeftArm({
        complete: () => {
          ctx.cross_arms(false, true)
          ria.cross_arms();
          setTimeout(() => {
            ctx.controlPanelActive = true
          }, 2500)
        }
      })
    }
  })
  characterSpeech(ctx.ayeData, 4)
  updateText(ctx, true, "Aye")
})


// Artboard 8 + Artboard 9
addSlide((ctx) => {
  console.log('Artboard 8 + 9');
  ctx.controlPanelActive = false;

  characterSpeech(ctx.riaData, 4)
  updateText(ctx, true, "Ria")

  aye.lowerRightArm({
    begin: () => {
      aye.lowerLeftArm()
      ria.uncross_arms({
        begin: () => {
          ctx.ria_speech()
        }
      })
    },
    complete: () => {
      anime({
        begin: () => {
          ctx.cross_arms(true, false);
          ria.raiseRightArm({
            rotate: '-120deg',
            delay: 100
          })
        }
      })
      createBlinkAnimation("devyn"),
      aye.exit({
        delay: 1400,
        duration: 2500,
        complete: () => {
          aye.enter({
            delay: 1400,
            duration: 1000,
            // begin: () => {
            //   updateText(ctx, true, "")
            // }
          });
          // setTimeout(() => {
            ctx.controlPanelActive = true
          // }, 1000)
        }
      })
    }
  })
})


// Artboard 10
addSlide((ctx) => {
  console.log('Artboard 10');
  ctx.controlPanelActive = false;
  characterSpeech(ctx.devynData, 4)
  updateText(ctx, true, "Devyn")

  aye.walk({
    left: ['0%', '30%'],
    duration: 2000
  })

  devyn.walk({
    left: ['80%', '55%'],
    duration: 2000,
    complete: () => {
      devyn.raiseLeftArm({
        complete: () => {
          ctx.controlPanelActive = true;
        }
      })
    }
  })
})

// Artboard 11
addSlide((ctx) => {
  console.log('Artboard 11');
  ctx.controlPanelActive = false;

  characterSpeech(ctx.ayeData, 4)
  updateText(ctx, true, "Aye")

  aye.scratchHead({
    duration: 1000,
    begin: () => {
      ctx.ayeData = ["unsure", "happy_green_orb"];
      devyn.lowerLeftArm();
    },
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})


// Artboard 12
addSlide((ctx) => {
  console.log('Artboard 12');
  ctx.controlPanelActive = false;

  characterSpeech(ctx.devynData, 4)
  updateText(ctx, true, "Devyn")

  devyn.raiseRightArm({
    duration: 1000,
    begin: () => {
      ctx.ayeData = ["neutral", "puke_green_orb"]
      aye.lowerLeftArm();

    },
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})


// Artboard 13
addSlide((ctx) => {
  console.log('Artboard 13');
  ctx.controlPanelActive = false;

  characterSpeech(ctx.ayeData, 4)
  updateText(ctx, true, "Aye")

  devyn.lowerRightArm();

  aye.raiseLeftArm({
    duration: 1000,
    begin: () => {
      ctx.ayeData = ["frown", "mustard_orb"];
    },
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})


// Artboard 14
addSlide((ctx) => {
  console.log('Artboard 14');
  ctx.controlPanelActive = false;

  characterSpeech(ctx.devynData, 4)
  updateText(ctx, true, "Devyn")

  aye.lowerLeftArm({
    duration: 1000,
    begin: () => {
      ctx.ayeData = ["neutral", "mustard_orb"];
      devyn.raiseLeftArm();
    },
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})


// Artboard 15
addSlide((ctx) => {
  console.log('Artboard 15');
  ctx.controlPanelActive = false;

  characterSpeech(ctx.ayeData, 4)
  updateText(ctx, true, "Aye")

  aye.scratchHead({
    duration: 1000,
    begin: () => {
      ctx.ayeData = ["unsure", "mustard_orb"];
      devyn.lowerLeftArm();
    },
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})


// Artboard 16
addSlide((ctx) => {
  console.log('Artboard 16');
  ctx.controlPanelActive = false;

  characterSpeech(ctx.devynData, 4)
  updateText(ctx, true, "Devyn")

  aye.lowerLeftArm({
    duration: 1000,
    begin: () => {
      ctx.ayeData = ["neutral", "happy_green_orb"];
      devyn.raiseRightArm();
    },
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})


// Artboard 17
addSlide((ctx) => {
  console.log('Artboard 17');
  ctx.controlPanelActive = false;

  characterSpeech(ctx.ayeData, 4)
  updateText(ctx, true, "Aye")

  aye.raiseLeftArm({
    duration: 1000,
    begin: () => {
      ctx.ayeData = ["smile", "happy_green_orb"];
      devyn.lowerRightArm();
    },
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})


// Artboard 18
addSlide((ctx) => {
  console.log('Artboard 18');
  ctx.controlPanelActive = false;

  characterSpeech(ctx.ayeData, 4)
  updateText(ctx, true, "Aye")

  aye.raiseRightArm({
    duration: 1000,
    begin: () => {
      ctx.ayeData = ["unsure", "happy_green_orb"];
      aye.raiseLeftForeArm({
        offset: '-100'
      });
    },
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})


// Artboard 19
addSlide((ctx) => {
  console.log('Artboard 19');
  ctx.controlPanelActive = false;

  characterSpeech(ctx.devynData, 4)
  updateText(ctx, true, "Devyn")

  aye.lowerLeftArm({
    duration: 1000,
    begin: () => {
      ctx.ayeData = ["smile", "happy_green_orb"];
      aye.lowerRightArm();
      devyn.raiseRightArm();
    },
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})


// Artboard 20
addSlide((ctx) => {
  console.log('Artboard 20');
  ctx.controlPanelActive = false;

  characterSpeech(ctx.devynData, 4)
  updateText(ctx, true, "Devyn")

  devyn.lowerRightArm({
    duration: 1000,
    begin: () => {
      ctx.ayeData = ["smile", "happy_green_orb"];
      devyn.raiseLeftArm();
    },
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})


// Artboard 21
addSlide((ctx) => {
  console.log('Artboard 21');
  ctx.controlPanelActive = false;

  updateText(ctx, true, "Devyn")

  aye.spinAndWalk({
    delay: 1400,
    left: ['30%', '-55%'],
    flipped: true
  });

  devyn.walk({
    left: ['55%', '-20%'],
    begin: () => {
      ctx.ayeData = ["smile", "happy_green_orb"];
      devyn.lowerLeftArm();
    },
    complete: () => {
      ctx.turnOffMusic()
      ctx.controlPanelActive = true
      ctx.toggleModalLayer(true)
    }
  })
})

// Artboard 22
addSlide((ctx) => {
  console.log('Artboard 22');
  updateText(ctx, true, "")
  ctx.controlPanelActive = true;
})

export { slides }



// WEBPACK FOOTER //
// ./src/components/module_5/js/slides.js